import { AxiosInstance } from 'axios';
import { ChecklistDeploy, ChecklistOverview } from '../../api/rollout';

const body = <T>(data: unknown): T => (typeof data === 'string' && data.length > 0 ? JSON.parse(data) : data) as T;

/** The overview with the deploy someone picked to go next; mirrors ChecklistOverview on the server. */
export type ChecklistOverviewWithChoice = ChecklistOverview & { chosen?: string | null };

/** Picks the deploy to go next, ahead of the plan's order; null goes back to that order. Writes. */
export const chooseNextDeploy = async (axios: AxiosInstance, deploy: string | null): Promise<ChecklistOverviewWithChoice> =>
    body((await axios.put('/Rollout/checklist/next', { deploy }, { headers: { 'Content-Type': 'application/json' } })).data);

/** Measures one deploy now: go/no-go, builds and watch. Reads. */
export const measureDeploy = async (axios: AxiosInstance, deploy: string): Promise<ChecklistDeploy> =>
    body((await axios.get('/Rollout/checklist', { params: { deploy } })).data);
